import List from '@utils/list'
import getData from './config/getData'
import MultipleTable from '@utils/multiple-table'
import operation from './config/operation'
import http from '@/plugin/axios'
import DotStatus from '@/components/common/dot-status/dot-status.vue'
const { Search, Tabs, Table, Operation, Jurisdiction } = List

const jurisdiction = new Jurisdiction()
  .lib('add').to('Ordersupplier.Externalcontrol.Add')

const dots = new Map([
  [1, { text: 'orderpurchase.externalcontrol.checkStatus1', color: '#FBA923' }],
  [2, { text: 'orderpurchase.externalcontrol.checkStatus2', color: '#02BD6D' }],
  [3, { text: 'orderpurchase.externalcontrol.checkStatus3', color: '#61BE00' }],
  [4, { text: 'orderpurchase.externalcontrol.checkStatus4', color: '#008EE3' }]
])

function edit(this: any, row: any) {
  this.$router.push({ name: 'Ordersupplier.Externalcontrol.Modify', params: { checkApplyNo: row.checkApplyNo }})
}
async function remove(this: any, row: any) {
  await this.$confirm(this.$t('message.delete'))
  await http({
    url: '/srmCheckApply/deleteCheckApply',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { checkApplyNos: [row.checkApplyNo] }
  })
  this.refresh()
}

async function check(this: any, row: any) {
  await http({
    url: '/srmCheckApply/updateCheckStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { checkStatus: 2, oldCheckStatus: 1, checkApplyNos: [row.checkApplyNo] }
  })
  this.refresh()
}
const multipleOperation = new Operation('ordersupplier.externalcontrol')
  .add('edit').show(row => row.checkStatus === 1).handle(edit)
  .add('remove').show(row => row.checkStatus === 1).handle(remove)
  .add('check').show(row => row.checkStatus === 1).handle(check)

const tabs = new Tabs()
  .url('/srmCheckApply/getStatusCount', process.env.VUE_APP_PURCHASE_API)
  .default('0')
  .name('checkStatusName')
  .value('checkStatus')
  .count('checkStatusCount')
  .prop('checkStatus')

const search = new Search('orderpurchase.externalcontrol')
  .placeholder('searchPlaceholder')
  .add('purchaseNo')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('startApplyDate').merge('date').label('startApplyDate')
  .add('endApplyDate').merge('date').label('endApplyDate')

const childTable = new Table('orderpurchase.externalcontrol')
  .edit(true)
  .type('index')
  .sortable(false)
  .operation(operation)
  .add('purchaseNo')
  .add('purchaseSeq').width(110)
  .add('purchasePhaseSeq')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('applyQty')
  .add('qualifiedQty')
  .add('checkStatus').editor({ component: DotStatus }).bind('dots', dots)

const table = new MultipleTable('orderpurchase.externalcontrol')
  .table(childTable)
  .type('none')
  .listProp('list')
  .add('checkApplyNo')
  .add('applyDate').date()
  .add('supOfficeName')
  .add('purOfficeName')

export default new List()
  .api(getData)
  .jurisdiction(jurisdiction)
  .tabs(tabs)
  .search(search)
  .table(table)
  .operation(multipleOperation)
  .end()
